export default __webpack_public_path__ + "static/media/6k.66f85a1d.gif";